<template>
  <div class="news-container" id="news-container">
    <div class="news-nav-wrapper">
      <div class="news-nav-pack news-nav-container-fixed">
        <div class="news-nav-container" :style="tagStyle">
          <ul class="news-nav-common">
            <li class="nav-common-item" :clickReportwlb="config.clickReportwlb"
                v-for="(config, index) in newsTagCfg"
                :class="[curType == config.type ? 'news-active' : '' ]"
                v-html="config.name" @click.stop="changeTab(config, index, 1)"
                v-bind:key="index"
            >
            </li>
          </ul>
          <i class="nav-active-line" style="left: 14px;"></i>
          <div class="info_tips">
            <div class="new_tuijian sus_info" id="newsTuijian" style="display: none;">
              <span v-html="'为您推荐了 ' + newsHintBanner.newsCnt + ' 条新闻'"></span>
            </div>
            <div class="no_read sus_info" id="newsNoRead" style="display: none;">
                <span>
                  <span v-html="'您有 ' + newsHintBanner.newsCnt + ' 条未读新闻，'"></span>
                  <a href='javascript:;' @click="showMore()">点击查看</a>
                  <i class='tips_close' @click="closeTips()"></i>
                </span>
            </div>
            <div class="no_news sus_info" id="newsNoNews" style="display: none;">
              <span>暂无可推荐的新闻，请稍后再试</span>
            </div>
          </div>
        </div>
        <div class="news-bd-wrapper">
          <ul class="news-content-wrapper news-content-active"
              v-for="(config, index) in newsTagCfg" v-bind:id="config.type"
              style="display: block; margin-top: 2px;" v-bind:key="index"
              v-show="config.show" >
            <li v-for="(newsInfo, newsIdx) in newsTagData[config.type]" v-bind:key="newsIdx" :class="newsInfo.newsClass">
              <NewsTplDf v-bind:newsInfo="newsInfo" v-bind:compName="compName" v-bind:tag="config.type" v-bind:pageType="pageType" v-if="newsInfo.provider === 'df'"></NewsTplDf>
              <NewsTplAdBaidu v-bind:newsAdInfo="newsInfo" v-bind:compName="compName" v-bind:tagIdx="curIdx" v-bind:report_max_line_300="report_max_line_300" v-bind:tag="config.type" v-bind:pageType="pageType" v-if="newsInfo.provider === 'bdwm'"></NewsTplAdBaidu>
              <NewsTplAd360 v-bind:newsAdInfo="newsInfo" v-bind:compName="compName" v-bind:tag="config.type" v-bind:pageType="pageType" v-if="newsInfo.provider === '360'"></NewsTplAd360>
            </li>
          </ul>
          <div v-show="report_max_line_300[curIdx]===1" style="margin: 10px 35px;background: #fff5d5;height: 34px;line-height: 34px;font-size: 14px;color: #cc671f;">
            <span>
              到底啦，休息一会吧～
              <i v-show="pageType==='newtab'" style="display: inline-block;width: 20px;height: 20px;background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABC0lEQVQ4jdXSTSuEURjG8d8zoaQZKWVtQ2HjK7ASK0XZapooFpaKr+AlksVkY4eaDWXnMyjJQvaiJlNSs3ks5hw9NI0ZO1fdnc459//qOi9JqVTyQ2MoYgbDYe0J1yjjPtOb5jKTHhziBi9YRH+oJVTD3jF6I9SVga/whpEwZnUbah8nuAwJxQS7AVpoAmdVCz1V7MQE45jHKNIWcFSKZTzEBEUcBfd2VcMBJE1eoSPlfm/5DwYptv/AbmIvJlhFoQO4gHWUo0FF44clbcBJ6K3gLhpsaPz5M+RbwHmcYyAwX5dYxyye8ahxvgl0ow+T2Ap7r5gLzLdXqGMNUxjCBd6D6SkGMY0VfEToExOFOF7IeJGXAAAAAElFTkSuQmCC') no-repeat center;vertical-align: middle;margin-left: 10px;cursor: pointer;" title="刷新" @click="goTopAdRefresh()"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import NewsTplDf from './NewsTpl/NewsTplDf';
import NewsTplAdBaidu from './NewsTpl/NewsTplAdBaidu';
import NewsTplAd360 from './NewsTpl/NewsTplAd360';
import $ from 'jquery';
import 'jquery.transit';
import news from '../api/news';
import statistics from "../api/statistics";
import util from '../api/util';
import _ from 'lodash';
import ad from '../api/ad';
import filter from '../api/filter.js';

export default {
  name: 'LeftNews',
  components: {
    NewsTplDf,
    NewsTplAdBaidu,
    NewsTplAd360
  },
  data () {
    return {
      compName: 'LeftNews',
      curType: 'toutiao',
      curIdx: 0,
      newsTagCfg: [
        {type: 'toutiao', name: '推荐', show: false, params: null, clickReportwlb: 'ChangeTab_toutiao'},
        {type: 'shehui', name: '社会', show: false, params: null, clickReportwlb: 'ChangeTab_shehui'},
        {type: 'guonei', name: '国内', show: false, params: null, clickReportwlb: 'ChangeTab_guonei'},
        {type: 'guoji', name: '国际', show: false, params: null, clickReportwlb: 'ChangeTab_guoji'},
        {type: 'keji', name: '科技', show: false, params: null, clickReportwlb: 'ChangeTab_keji'},
        {type: 'caijing', name: '财经', show: false, params: null, clickReportwlb: 'ChangeTab_caijing'},
        {type: 'qiche', name: '汽车', show: false, params: null, clickReportwlb: 'ChangeTab_qiche'},
        {type: 'yule', name: '娱乐', show: false, params: null, clickReportwlb: 'ChangeTab_yule'},
        {type: 'shishang', name: '时尚', show: false, params: null, clickReportwlb: 'ChangeTab_shishang'},
        {type: 'tiyu', name: '体育', show: false, params: null, clickReportwlb: 'ChangeTab_tiyu'}
      ],
      newsTagData: {
        toutiao: [],
        shehui: [],
        guonei: [],
        guoji: [],
        keji: [],
        caijing:[],
        qiche:[],
        yule:[],
        shishang:[],
        tiyu:[]
      },
      newsHintBanner: {
        newsCnt: 10
      },
      lastEndKey: '',
      lastNewKey: '',
      loadState: 0,
      report_max_line_300: [],
      reqTimes: 1,
      iframeRect: {},
      tagStyle: 'display: none;',
      intBaiduAdCnt: 0,
    };
  },
  props: ['compsCfg', 'showNewsTag', 'pageType'],
  mounted () {
    this.initComps();
    this.$bus.$on('changeTab', (data) => {
      this.changeTab(this.newsTagCfg[data.index], data.index, data.sendClick);
    });
    this.$bus.$on('refreshTab', _.debounce(() => {
      this.loadNewsData(1);
    }, 500));
    this.$bus.$on('loadMore', _.debounce(() => {
      if (this.loadState <= 0 || ((new Date().getTime()) - this.loadState) >= 20) {
        if (this.report_max_line_300[this.curIdx] !== 1) {
          this.loadNewsData(0);
          var loadMoreKey = '';
          if (this.pageType == 'errorpage') {
            loadMoreKey = 'Error_LoadMore_News';
          } else {
            loadMoreKey = 'LoadMore_News_' + this.curType;
          }
          statistics.ajax99(loadMoreKey);
        } else {
					let curNewsCnt = document.querySelector('#' + this.curType);
          let ifrmHeight = 0;
          if (this.pageType === 'newtab') {
            ifrmHeight = parseInt(curNewsCnt.offsetHeight) + 100;
          } else {
            ifrmHeight = parseInt(curNewsCnt.offsetHeight) + 230;
          }
          this.$bus.$emit('refreshHeight', {
            curHeight: ifrmHeight
          });
          this.$bus.$emit('refreshRight', {
            curType: this.curType
          });
          this.$bus.$emit('sendMessage', {
            action: 'refreshHeigh',
            height: ifrmHeight,
            data: {
              height: ifrmHeight,
              loadState: true
            }
          });
        }
      }
    }, 500));
    this.$bus.$on('closeTips', () => {
      this.closeTipsNoSendMessage();
    });
    this.$bus.$on('showReport', (data) => {
      this.iframeRect = data.rect;
    });
    this.$bus.$emit('sendMessage', {
      action: 'newsPageOK',
      data: {
        newsTagCfg: this.newsTagCfg,
        curType: this.curType,
        curIdx: this.curIdx
      }
    });
    if (this.pageType === 'newtab') {
      this.tagStyle = 'visibility:visible;padding-bottom: 6px;';
    } else {
      this.tagStyle = 'display: none;';
    }
  },
  watch: {
    showNewsTag (newVal, oldVal) {
      if (this.pageType === 'newtab') {
        this.tagStyle = 'visibility: ' + (newVal ? 'visible' : 'hidden')+ ';padding-bottom: 6px;';
      } else {
        this.tagStyle = 'display: none;';
      }
    }
  },
  methods: {
    initComps () {
      this.loadNewsData(0);
    },
    changeTab (tabInfo, index, sendClick) {
      let loadType = 1;
      sendClick === 1 && statistics.ajax99(tabInfo['clickReportwlb']);
      if (index !== this.curIdx) {
        this.newsTagCfg[this.curIdx].show = false;
        this.updateTab(tabInfo.type, index);
        loadType = 0;
        // 切换标签时初始化百度网盟展示逻辑
        this.intBaiduAdCnt = 0;
      }
      this.closeAllBanner();
      this.loadNewsData(loadType);
    },
    updateTab (type, index) {
      this.curType = type;
      this.curIdx = index;
      this.$nextTick(() => {
        $('.news-nav-container .nav-active-line').css({left: (14 + index * 63.6)});
        this.$bus.$emit('sendMessage', {
          action: 'changeCurType',
          data: {
            curType: this.curType,
            curIdx: this.curIdx,
            navActiveLineLeft: (14 + index * 63.6)
          }
        });
      });
    },
    loadNewsData (loadType) {
      let params, appenType = loadType;
      if (!!this.newsTagCfg[this.curIdx]['params']) {
        params = this.newsTagCfg[this.curIdx]['params'];
        if (loadType === 1) {
          params.uppgnum -= 1;
          params.idx = (Math.abs(params.uppgnum) - 1) * 10;
          params.pgnum = params.uppgnum;
        } else {
          params.downpgnum += 1;
          params.idx = 0;
          params.pgnum = params.downpgnum;
        }
        params.newsnum = 10;
      } else {
        params = this.compsCfg.newsList.params;
        params.pgnum = 1;
        params.idx = 0;
        params.type = this.curType;
        params.startkey = '';
        params.newkey = '';
        params.newsnum = 20;
        params.downpgnum = 1;
        params.uppgnum = 0;
      }
      params.fnName = 'getList';
      params.uid = util.getUUID();
      params.report = {
        click_report: (this.compsCfg.newsList['click_report'] || `Click_News_${this.curType}_9.X`)
      };
      this.newsTagCfg[this.curIdx].show = true;
      this.newsTagCfg[this.curIdx]['params'] = params;
      // 错误页接入导航版数据
      // let newsType = (this.pageType == 'errorpage') ? 'df_2345' : this.compsCfg.newsList.type;
      // 接入东方数据
      let newsType = this.compsCfg.newsList.type;
      news.getList(newsType, params, (err, res) => {
        if (err || !res.hasOwnProperty('data')) {
          console.log('LeftNews loadNewsData err', err);
        } else {
          // 过滤新闻敏感词
          filter.filterWithPath(res, 'data.(*).topic');
          let adCfg = this.compsCfg.ad, newsList = res.data, intAdCnt = 0, newsListCount = newsList.length;
          let arrLoadAdsIdx = [], oldNewsCnt = this.newsTagData[this.curType].length;
          let nextStep = (this.pageType === 'newtab' ? 6 : 6);
          let tabStartPos = (this.pageType === 'newtab' ? 2 : 5);
          let uuidIndex = 0;
          for(let startPos = tabStartPos; startPos <= res.data.length; startPos += nextStep) {
            let adsIdx = this.curType + '_' + adCfg.type + '_' + startPos + '_' + ((Math.random()+ '').replace('.', '_'));
            if (adCfg.type === 'bdwm') {
              if (this.pageType === 'newtab') {
                // 新标签页展示逻辑 大图+大图+大图+大图+小图+大图+小图+大图……依次类推
                uuidIndex = (this.intBaiduAdCnt <= 3) ? 0 : ((this.intBaiduAdCnt + adCfg.uuid.length + 1) % adCfg.uuid.length);
                newsList.splice(startPos, 0, {
                  itemType: 'bdwm',
                  divId: adsIdx,
                  provider: 'bdwm',
                  show_report_50bang: 'NewTab_AdShow_Baidu',
                  newsClass: 'news-pack bdwm',
                  uid: adCfg.uuid[uuidIndex]
                });
                this.intBaiduAdCnt += 1;
              } else {
                newsList.splice(startPos, 0, {
                  itemType: 'bdwm',
                  divId: adsIdx,
                  provider: 'bdwm',
                  show_report_50bang: 'NewTab_AdShow_Baidu',
                  newsClass: 'news-pack bdwm',
                  uid: adCfg.uuid[intAdCnt % adCfg.uuid.length]
                });
              }
            } else if (adCfg.type === '360') {
              newsList.splice(startPos, 0, {
                itemType: '360',
                divId: adsIdx,
                provider: '360',
                newsClass: '',
                show: false,
                uid: adCfg.uuid[intAdCnt % adCfg.uuid.length]
              });
              arrLoadAdsIdx.push(startPos + oldNewsCnt);
              if (arrLoadAdsIdx.length >= 2 && newsListCount < 20) {
                break ;
              }
            }
            intAdCnt++;
          }
          let oldTagData = this.newsTagData[this.curType];
          if (appenType === 1) {
            if (res.endkey === '' || res.newkey === '' || (this.lastEndKey !== res.endkey && this.lastNewKey !== res.newkey)) {
              if (res.data.length > 0) {
                this.displayHintBanner('newsTuijian', newsListCount);
                this.newsTagData[this.curType] = newsList.concat(oldTagData);
              }
            } else {
              this.displayHintBanner('newsNoNews', 0);
            }
          } else {
            this.newsTagData[this.curType] = this.newsTagData[this.curType].concat(newsList);
          }
          if (this.newsTagData[this.curType].length >= 300) {
            this.report_max_line_300[this.curIdx] = 1;
          }
          this.newsTagCfg[this.curIdx]['params'].startkey = res.endkey;
          this.newsTagCfg[this.curIdx]['params'].newkey = res.newkey;
          this.lastEndKey = res.endkey;
          this.lastNewKey = res.newkey;
          this.reqTimes += 1;
          this.resetClocker(1);
          arrLoadAdsIdx.length > 0 && this.loadAdsList(arrLoadAdsIdx, adCfg, this.reqTimes);
          setTimeout(() => {
            this.loadState = 0;
            let curNewsCnt = document.querySelector('#' + this.curType);
            this.$bus.$emit('refreshRight', {
              curType: this.curType
            });
            this.$bus.$emit('refreshHeight', {
              curHeight: parseInt(curNewsCnt.offsetHeight) + 54 + 100
						});
						// console.log(parseInt(curNewsCnt.offsetHeight) + 54 + 100)
            this.$bus.$emit('sendMessage', {
              action: 'refreshHeigh',
              height: parseInt(curNewsCnt.offsetHeight) + 54 + 100,
              data: {
                height: parseInt(curNewsCnt.offsetHeight) + 54 + 100,
                loadState: true
              }
            });
            if (adCfg.type === 'bdwm') {
              this.$bus.$emit('showReport', {
                rect: this.iframeRect
              });
            }
          }, 500);
        }
      });
    },
    displayHintBanner (whichBanner, intNewsCnt) {
      this.newsHintBanner.newsCnt = intNewsCnt;
      this.newsHintBanner.curBanner = whichBanner;
      this.closeAllBanner();
      if (whichBanner !== '') {
        if (document.getElementById(whichBanner)) {
          document.getElementById(whichBanner).classList.remove('dis');
          document.getElementById(whichBanner).style.display = 'block';
          this.$bus.$emit('sendMessage', {
            action: 'displayHintBanner',
            data: {
              whichBanner: whichBanner,
              intNewsCnt: intNewsCnt
            }
          });
          clearTimeout(this.hintClock);
          if (whichBanner !== 'newsNoRead') {
            this.hintClock = setTimeout(function () {
              var domEle = document.getElementById(whichBanner);
              domEle.classList.add('dis');
              domEle.setAttribute('style', 'display:none;');
              this.newsHintBanner.curBanner = whichBanner;
              this.newsHintBanner.newsCnt = 0;
            }.bind(this), 1000);
          }
        }
      }
    },
    closeAllBanner () {
      ['newsTuijian', 'newsNoRead', 'newsNoNews'].forEach(function(val){
        var domEle = document.getElementById(val)
        domEle.setAttribute('style', 'display:none;')
      });
      this.$bus.$emit('sendMessage', { action: 'closeAllBanner' });
    },
    closeTipsNoSendMessage () {
      var target = document.getElementsByClassName('tips_close')[0].parentNode.parentNode;
      target.setAttribute('class', 'no_read sus_info dis');
      setTimeout(function () {
        target.style.cssText = 'display:none';
        this.resetClocker(1);
      }.bind(this), 190)
    },
    closeTips() {
      this.$bus.$emit('sendMessage',{action: 'closeTips'});
      this.closeTipsNoSendMessage();
    },
    showMore () {
      this.loadNewsData(1);
      statistics.ajax99('Missbanner_click'); // 信息流未读提醒横幅点击刷新次数
      this.closeTips();
    },
    resetClocker (setClock) {
      //  刷新定时器
      clearTimeout(this.tabClock);
      if (setClock > 0) {
        this.tabClock = setTimeout(function () {
          this.displayHintBanner('newsNoRead', 10);
        }.bind(this), 600000);
      }
    },

    /**
     * 置顶刷新
     */
    goTopAdRefresh () {
      let ajaxKey = 'Refresh';
      if (ajaxKey.indexOf('NewTab') < 0 && ajaxKey.indexOf('Error') < 0) {
        let prefix = this.pageType === 'newtab' ? 'NewTab' : 'Error';
        ajaxKey = prefix + '_' + ajaxKey;
      }
      statistics.ajax99(ajaxKey);
      this.changeTab(this.newsTagCfg[this.curIdx], this.curIdx, 0);
    },
    /**
     *
     * @param arrLoadAdsIdx
     * @param adCfg
     * @param reqTimes
     */
    loadAdsList (arrLoadAdsIdx, adCfg, reqTimes) {
      ad.getAdsList(adCfg.type, {
        showid: adCfg.uuid[0],
        reqtimes: reqTimes,
        impct: arrLoadAdsIdx.length,
        queryword: '',
        cname: encodeURIComponent(this.newsTagCfg[this.curIdx].name)
      }, (err, list) => {
        if (err || !list || !list['ads']) {
          console.log('Left New loadAdsList err', arrLoadAdsIdx, adCfg, reqTimes);
        } else {
          list.ads.forEach((adsInfo, idx) => {
            let adsImgs = [];
            if (adsInfo['assets'] && adsInfo['assets'].length > 0) {
              adsInfo['assets'].forEach((ad360Info) => {
                if (adsImgs.length < 4) {
                  adsImgs.push({
                    src: ad360Info.img,
                    url: ad360Info.curl
                  });
                }
              });
            } else {
              adsImgs.push({url: adsInfo.curl, src: adsInfo.img});
            }
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].miniimg = adsImgs;
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].show = true;
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].provider = '360';
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].itemType = '360';
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].divId = 'LeftNews_' + adCfg.type + '_' + arrLoadAdsIdx[idx] + '_' + (Math.random() + '').replace('.', '');
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].url = adsInfo.curl;
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].show_report_50bang = adCfg.show_report;
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].click_report_50bang = adCfg.click_report;
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].uid = adCfg.uuid[0];
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].topic = adsInfo.title;
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].imptk = adsInfo.imptk;
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].clktk = adsInfo.clktk;
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].imgType = adsInfo.type;
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].newsClass = 'news-pack' + ((adsInfo.type === 3 || adsImgs.length >= 3) ? ' news-pics' : ' ');
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].showMorePos = (adsImgs.length <= 3 && adsImgs.length >= 2);
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].miniimg_size = adsImgs.length;
            this.newsTagData[this.curType][arrLoadAdsIdx[idx]].source = adsInfo.src;
          });
          setTimeout(() => {
            this.$bus.$emit('showReport', {
              rect: this.iframeRect
            });
          }, 100);
        }
      })
    }
  }
}
</script>
